// extracted by mini-css-extract-plugin
export var container = "_8y-0";
export var containerTopRight = "_8y-1";